export enum Variant {
  Light = 'light',
  Dark = 'dark',
  Blue = 'blue',
}

export type CopyProps = {
  children?: React.ReactNode;
  className?: string;
  title: string;
  subtitle?: string;
  overline?: string;
  paragraph?: string;
  variant?: Variant;
  isLargerTitle?: boolean;
  isXLargeTitle?: boolean;
  isLargerParagraph?: boolean;
  svg?: string;
};
